module.exports = __webpack_public_path__ + "img/sleeve upper flounce length.fe843564.png";